import { Home } from "./home";
import PrivacyPolicy from "./privacy";
import TermsAndConditions from "./terms";

export const routes = [
  { path: "/", element: <Home /> },
  { path: "/routine/app/privacy", element: <PrivacyPolicy /> },
  { path: "/routine/app/terms", element: <TermsAndConditions /> },
];
